exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:320px){.day-month-year-container,.month-year-container{display:flex;flex-flow:row wrap;justify-content:space-between;max-width:328px}}@media (min-width:320px){.month-year-container{display:flex;flex-flow:row wrap;justify-content:space-between;max-width:200px}}.day-month-year-daymonth,.day-month-year-month{margin-bottom:8px}@media (min-width:320px){.day-month-year-daymonth,.day-month-year-month{margin:0;width:72px}}@media (min-width:320px){.day-month-year-year{width:120px}}.day-month-year-error-container{margin-top:5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/DayMonthYear/DayMonthYear.scss
 ** module id = 1230
 ** module chunks = 0
 **/